import {Game} from "../../Game";
import {gsap} from "gsap";

export class MonsterReelsView extends PIXI.Container {

    private _maskItem: PIXI.Graphics;

    constructor() {
        super();
        this.name = "MonsterReelsView";

        this.init();
    }

    private _monsterSymbolContainer: PIXI.Container;

    get monsterSymbolContainer(): PIXI.Container {
        return this._monsterSymbolContainer;
    }

    // #230
    public toggleMask(visible: boolean): void {
        if (visible) {
            if (this.mask === null) {
                this.mask = this._maskItem;
                this.addChild(this._maskItem);
            }
        } else {
            this.mask = null;
            this.removeChild(this._maskItem);
        }
    }

    public expandGrid(xOffset: number, yOffset: number, maskY: number, maskHeight: number, duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._monsterSymbolContainer, {
            duration,
            x: (Game.REEL_AREA_X - xOffset),
            y: (Game.REEL_AREA_Y - yOffset)
        });
        tl.to(this._maskItem, {
            duration,
            height: maskHeight,
            y: maskY
        }, "<");

        return tl;
    }

    private init(): void {
        this._monsterSymbolContainer = new PIXI.Container();
        this._monsterSymbolContainer.position.set(Game.REEL_AREA_X, Game.REEL_AREA_Y);

        const mask: PIXI.Graphics = new PIXI.Graphics();
        mask.beginFill();
        mask.drawRect(-90, 0, 900, 670);
        mask.endFill();
        mask.y = 25;
        this.mask = mask;
        this._maskItem = mask;

        if (Game.model.isRestore && Game.hasGridExpanded) {
            const xOffset: number = (Game.scaleFactor === 0.8 ? 35 : 41),
                yOffset: number = (Game.scaleFactor === 0.8 ? 35 : 40);

            this._monsterSymbolContainer.position.set(Game.REEL_AREA_X - xOffset, Game.REEL_AREA_Y - yOffset);

            // #410
            this._maskItem.height = ((Math.min(Game.ACTIVE_ROWS_NUM, Game.TOTAL_REELS_NUM)) * Game.SYMBOL_HEIGHT) + 50;
            this._maskItem.y = 15;
        }

        this.addChild(this._monsterSymbolContainer, mask);
    }
}